import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectMedia } from 'src/app/models/project.model';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { CutoffService } from 'src/app/services/cutoff.service';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-new-media',
  templateUrl: './new-media.component.html',
  styleUrls: ['./new-media.component.scss']
})
export class NewMediaComponent implements OnInit {
  dataSt!: any;
  idProyecto : number = 0;
  idProyectoCampana : number = 0;
  sucursalesCount = 0;
  isEdit : boolean = false;
  idMedio : number = 0;
  mostrarAdvertenciaArtesCompartidos = false;


  generatePoPs : boolean = false;
  generateSettings : any = {
    posiciones : 0,
    cantidadPoPs : 0,
    nombre: "",
    postfijo : "",
  }

  prioridadConf : any[] = [{id: 0, nombre: '', multiplicador : ''}]

  constructor(@Inject(MAT_DIALOG_DATA) public data : any, public dref: MatDialogRef<NewMediaComponent>,
    private _projService : ProjectsService,
    private _cutoff : CutoffService,
    private _main : MainService
  ) { }

  ngOnInit(): void {
    this.idProyecto =  this.data.id_proyecto;
    this.idProyectoCampana = this.data.id_proyecto;
    this.isEdit = this.data.isEdit;
    const imagenesCompartidasOriginal = this.data?.medio?.imagenes_compartidas;
    this.mostrarAdvertenciaArtesCompartidos = this.isEdit
      && (imagenesCompartidasOriginal === true || Number(imagenesCompartidasOriginal) === 1);
    console.log("see the data,", this.data);
    
    if(!this.isEdit){
      this.dataSt = {
        sucursalesVacias: false, multipleItems: false, filtroSucursales :false,
        name: '', popMaterials: [], segmentable: false, formato: "", descripcion : "", inventario_type : "", multiples_promociones: false, imagenes_compartidas: false
      }
  
    }else{

      this.dataSt = {
        sucursalesVacias: this.data.medio.sucursales_vacias , multipleItems: this.data.medio.multiples_elementos, filtroSucursales : this.data.medio.sucursal_filtro,
        name: this.data.medio.nombre, popMaterials: [], segmentable: this.data.medio.segmentable , formato: "", descripcion : this.data.medio.descripcion, inventario_type : "", multiples_promociones: this.data.medio.multiples_promociones, imagenes_compartidas: this.data.medio.imagenes_compartidas
      }

      this.selectedFormato = this.data.medio.formato;
      this.selectedInventario = this.data.medio.is_position_type == 1? this.data.medio.inventario_type.toString()+"p": this.data.medio.inventario_type.toString();
      this.idMedio = this.data.medio.id

      this.prioridadConf = this.data.medio.prioridad_filtro != '' ? JSON.parse(this.data.medio.prioridad_filtro) : [{id: 0, nombre: '', multiplicador : ''}];

      this.reglasAlcance = this.data.medio.sucursales_filtro != '' ? JSON.parse(this.data.medio.sucursales_filtro) : [];

      this.calculateStores();

    }
    
    this.getAtributos();
  }

  

  //atributosSucursales = ['DANGLER', 'MATERIAL', 'ATRIBUTO X'];
  comparadores = ['Igual a', 'Mayor o igual que', 'Menor o igual que'];
  atributos : any[] = [];
  
  reglasAlcance: any[] = [];
  alcance: string = '';
  selectedFormato = 0;
  
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  selectedInventario : string = "1";

  /* void close(0):
     Closes dialog. */
  close(): void { this.dref.close(); }

  /* boolean invalidInput(0):
     Validates all the field's data to enable the "Submit" button.
     > True if all fields valid. Otherwise, false. */
  invalidInput(): boolean {
    return (this.dataSt.name === '');
  }


  register(): void { 
    if(!this.data.medios.find((x:any) => x.nombre.toLowerCase().trim() ===  this.dataSt.name.toLowerCase().trim())){
      let registerData = {id_proyecto : this.idProyecto, nombre : this.dataSt.name, sucursal_filtro : this.dataSt.filtroSucursales, sucursales_vacias : this.dataSt.sucursalesVacias,
        multiples_elementos : this.dataSt.multipleItems, segmentable : this.dataSt.segmentable, formato : this.selectedFormato, prioridad_filtro : JSON.stringify(this.prioridadConf), sucursales_filtro : JSON.stringify(this.reglasAlcance), descripcion : this.dataSt.descripcion,
        inventario_type : this.selectedInventario.replace("p", ""), pops : [], is_position_type : this.selectedInventario.includes('p'), multiples_promociones : this.dataSt.multiples_promociones, imagenes_compartidas : this.dataSt.imagenes_compartidas}
 
        Swal.fire({
         icon: 'info',
         title: 'Guardando...',
         allowEscapeKey: false,
         allowOutsideClick: false,
         showConfirmButton: false,
         didOpen: () => {
           Swal.showLoading();
         }
       });
    let pops: any= [];
       if(this.generatePoPs){
        for (let i = 1; i <= this.generateSettings.cantidadPoPs; i++) {
          let postfijoParte = this.generateSettings.postfijo ? ` ${this.generateSettings.postfijo}` : '';
          pops.push({
            nombre: `${this.generateSettings.nombre}${postfijoParte}${i}`,
            prioridad: this.selectedFormato == 2 ? i : 0,
            posiciones: this.selectedFormato == 1 ? this.generateSettings.posiciones : 0,
            sucursales_filtro : "",
            precio : 0,
            cantidad : 0,
            reglas_distribucion : "",
            generate_config : true
          });
        }
       }
    
       registerData.pops = pops;

       this._projService.createMedio(registerData).subscribe(
         (result:any) => {
           if(result.message == "Success") {
             Swal.fire({
               icon: 'success',
               title: 'Guardado',
               html: 'Medio guardado correctamente'
             }).then(() => {            
               this.dref.close(this.dataSt);
             });
           }
         },
         (err:any) => {
           console.log(err);
           Swal.fire({
             icon: 'error',
             title: 'Error al guardar',
             text: 'Ocurrió un error al guardar los registros, por favor vuelva a intentarlo.'
           });
         }
       );
    }else{
      Swal.fire({
        icon: 'warning',
        title: 'Nombre duplicado',
        text: 'Ya existe un medio con este nombre'
      });
    }
   // this.dref.close(this.dataSt);
  }

  editedName : boolean = false;
  onChangeName(e : any){
    this.editedName = true;
  }

  numericalAtributes : any;

  onlyNumericalAtributos(){
    this.numericalAtributes = this.atributos.filter((x:any)=> x.type_id == 4 || x.type_id == 6 );
    return this.numericalAtributes;
  }

  edit(): void { 
    if(!this.editedName || !this.data.medios.find((x:any) => x.nombre.toLowerCase().trim() ===  this.dataSt.name.toLowerCase().trim())){
    let registerData = {id : this.idMedio, id_proyecto : this.idProyecto, nombre : this.dataSt.name, sucursal_filtro : this.dataSt.filtroSucursales, sucursales_vacias : this.dataSt.sucursalesVacias,
       multiples_elementos : this.dataSt.multipleItems, segmentable : this.dataSt.segmentable, formato : this.selectedFormato, prioridad_filtro : JSON.stringify(this.prioridadConf), sucursales_filtro : JSON.stringify(this.reglasAlcance), descripcion : this.dataSt.descripcion
       ,inventario_type : this.selectedInventario.replace("p", ""), is_position_type : this.selectedInventario.includes('p'), multiples_promociones : this.dataSt.multiples_promociones, imagenes_compartidas : this.dataSt.imagenes_compartidas}

       Swal.fire({
        icon: 'info',
        title: 'Guardando...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this._projService.editMedios(registerData).subscribe(
        (result:any) => {
          if(result.message == "Success") {
            Swal.fire({
              icon: 'success',
              title: 'Guardado',
              html: 'Medio guardado correctamente'
            }).then(() => {            
              this.dref.close(this.dataSt);
            });
          }
        },
        (err:any) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar',
            text: 'Ocurrió un error al guardar los registros, por favor vuelva a intentarlo.'
          });
        }
      );
    }else{
      Swal.fire({
        icon: 'warning',
        title: 'Nombre duplicado',
        text: 'Ya existe un medio con este nombre'
      });
    }
    
   // this.dref.close(this.dataSt);
  }

  agregarRegla() {
    this.reglasAlcance.push({
      nombre: null,
      id: null,
      operador: 1,
      valor: null
    });   
  }

  getRanges(rangeSelect : any){
    return rangeSelect.split("-");
  }

  converToObject(obj: string){
    try{
      return JSON.parse(obj);
    }catch(ex){
      return [];
    }
  }

  setItemName(value : any, rule : any){
    const selectedAtributo = this.atributos.find(x => x.id === value);
    if (selectedAtributo) {
        rule.nombre = selectedAtributo.name;
        if(rule.operador){
          rule.operador = 1;
        } 
    }
  }

  setItemNameAutocomplete(value : any, rule : any){
    const selectedAtributo = this.atributos.find(x => x.id === value);
    if (selectedAtributo) {
        rule.nombre = selectedAtributo.name;
        if(rule.operador){
          rule.operador = 1;
        } 
    }
  }

  onOperadorChange(rule: any) {
    const item = this.getItem(rule.id);
    if (rule.operador === 4 && item && item.type_id === 3) {
      if (!Array.isArray(rule.valor)) rule.valor = [];
    } else {

      rule.valor = null;
    }
    this.calculateStores();
  }

  private validateSingleRangeValue(value: string, item: any): number | null {
    if (!item || item.type_id !== 4 || value === null || value === '') {
      return Number(value);
    }

    const [min, max] = this.getRanges(item.select_data).map(Number);
    const numValue = Number(value);

    if (isNaN(numValue)) {
      Swal.fire({
        icon: 'error',
        title: 'Valor inválido',
        text: `"${value}" no es un número válido para este rango.`
      });
      return null;
    }

    if (numValue < min) {
      Swal.fire({
        icon: 'warning',
        title: 'Valor fuera de rango',
        text: `El valor de "${item.name}" no puede ser menor que ${min}. Se ajustará automáticamente a ${min}.`
      });
      return min;
    } else if (numValue > max) {
      Swal.fire({
        icon: 'warning',
        title: 'Valor fuera de rango',
        text: `El valor de "${item.name}" no puede ser mayor que ${max}. Se ajustará automáticamente a ${max}.`
      });
      return max;
    }
    return numValue;
  }

  addChip(rule: any, event: MatChipInputEvent): void {
    const input = event.input;
    let value = (event.value || '').trim();
    const item = this.getItem(rule.id);

    if (value && rule.operador === 4) {
      if (!Array.isArray(rule.valor)) {
        rule.valor = [];
      }
      if (item && item.type_id === 4) { // Apply range validation for type_id 4
        const validatedValue = this.validateSingleRangeValue(value, item);
        if (validatedValue !== null) {
          value = String(validatedValue);
          if (!rule.valor.includes(value)) {
            rule.valor.push(value);
            this.calculateStores();
          }
        }
      } else if (!rule.valor.includes(value)) { // For other types, just add if not duplicate
        rule.valor.push(value);
        this.calculateStores();
      }
    }
    if (input) {
      input.value = '';
    }
  }

  removeChip(rule: any, chip: string): void {
    if (!Array.isArray(rule.valor)) {
      return;
    }
    const index = rule.valor.indexOf(chip);

    if (index >= 0) {
      rule.valor.splice(index, 1);
      this.calculateStores();
    }
  }

  getItem(atribute_id : any) : any{
    return this.atributos.filter(x=>  x.id === atribute_id)[0];
  }

  loadedcal : boolean = false;

  hasReglas = true;

  calculateStores(){
    this.loadedcal =  false;
    if(this.reglasAlcance && this.reglasAlcance.length != 0){
       this.hasReglas = true;
          this._cutoff.getCutOffFile(this.idProyectoCampana, [], this.reglasAlcance).then((x:any)=>{
               this.sucursalesCount = x.length;
                console.log("reglas suc", x);
                this.loadedcal =  true;
               
           });
    }else{
      this.hasReglas = false;
    }
    //this.sucursalesCount = this._cutoff.filtrarSucursales(this.reglasAlcance).length;
  }

  getAtributos(){
    this._main.ShowLoading();
    this._cutoff.getAtributos().subscribe((x: any) => {
      this._main.HideLoading();

      this.atributos = x.data;
      this.onlyNumericalAtributos();

    });
  }

  eliminarRegla(index: number) {
    this.reglasAlcance.splice(index, 1);
    this.calculateStores(); 
  }

  trackByFn(index: number, item: any): number {
    return index;
  }
}
